import React, { Suspense } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import CustomRoutes from './routes'
import Loader from 'components/ui-kit/Loader/index'
import { ThemeProvider } from 'ThemeContext'

const Routes = () => (
  <Router>
    <ThemeProvider>
      <Suspense fallback={<Loader />}>
        <CustomRoutes />
      </Suspense>
    </ThemeProvider>
  </Router>
)

export default Routes
